import React from "react";
import { MessageCircle, Target, Rocket, BarChart3 } from "lucide-react";
import { Reveal } from "../lib/motion";
import { PROCESS } from "../data/site";

const ICONS = { MessageCircle, Target, Rocket, BarChart3 };

export const Process = () => {
  return (
    <section id="proces" className="relative py-[clamp(64px,9vw,120px)] bg-surface/30 border-y border-white/10" data-testid="process-section">
      <div className="container-pm">
        <Reveal className="mb-14">
          <p className="eyebrow mb-4">Jak wygląda współpraca?</p>
          <h2 className="font-display font-semibold text-white text-[clamp(34px,4.4vw,58px)] leading-[1.02] tracking-[-0.035em] max-w-[20ch]">
            Prosty proces. <span className="text-coral">Zero chaosu.</span>
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PROCESS.map((step, i) => {
            const Icon = ICONS[step.icon];
            return (
              <Reveal key={step.n} delay={i * 0.1} className="relative">
                <div className="pm-card card-glow h-full p-7 relative overflow-hidden">
                  <div className="flex items-center justify-between mb-8">
                    <span className="glow-badge flex items-center justify-center w-9 h-9 rounded-full bg-coral text-white text-sm font-bold font-display">
                      {step.n}
                    </span>
                    <Icon className="text-coral glow-icon" size={22} strokeWidth={1.6} />
                  </div>
                  <h3 className="font-display font-semibold text-xl text-white mb-2">{step.title}</h3>
                  <p className="text-sm text-white/65 leading-relaxed">{step.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
